export default __webpack_public_path__ + "static/media/osk-logo.ee29d537.png";